module.exports = __webpack_public_path__ + "img/common-file-text-sync.44f1a652.svg";